package floris.graphics.repo

import floris.graphics.NetworkingConfig
import floris.graphics.getRequest
import floris.graphics.models.NetworkResponse
import floris.graphics.models.domain.models.user.User
import floris.graphics.models.domain.models.user.toUser
import floris.graphics.models.dto.requests.user.UpdatePassword
import floris.graphics.models.dto.requests.user.UpdateUser
import floris.graphics.models.dto.requests.user.UserDto
import floris.graphics.models.dto.responses.ErrorResponse
import floris.graphics.putRequest

object UserRepo {
    private val usersUrl = "${NetworkingConfig.baseUrl}/api/v1/users"

    suspend fun getCurrentUser(): User? {
        val url = "$usersUrl/me"

        val response: NetworkResponse<UserDto, ErrorResponse> = getRequest(url)

        return when (response) {
            is NetworkResponse.Success -> response.body.toUser()
            else -> null
        }
    }

    suspend fun updateCurrentUser(user: UpdateUser): User? {
        val url = "$usersUrl/me"
        val response: NetworkResponse<UserDto, ErrorResponse> = putRequest(resource = url, body = user)

        return when (response) {
            is NetworkResponse.Success -> response.body.toUser()
            else -> null
        }
    }

    suspend fun updatePasswordCurrentUser(updatePassword: UpdatePassword): User? {
        val url = "$usersUrl/me/password"
        val response: NetworkResponse<UserDto, ErrorResponse> = putRequest(resource = url, body = updatePassword)

        return when (response) {
            is NetworkResponse.Success -> response.body.toUser()
            else -> null
        }
    }
}
